import React from 'react';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center pt-20 pb-32 px-6 md:px-12" data-id="element-95">
      {/* Background Image — shipyard/industrial port */}
      <div className="absolute inset-0 z-0 bg-cover bg-center" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1590846406792-0adc7f938f1d?q=80&w=2000&auto=format&fit=crop)'
    }} data-id="element-96">
        <div className="absolute inset-0 bg-dark/75" data-id="element-97"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto w-full" data-id="element-98">
        {/* Badge */}
        <div className="flex items-center gap-3 mb-6" data-id="element-99">
          <div className="w-8 h-8 bg-primary rounded flex items-center justify-center" data-id="element-100">
            <svg width="14" height="10" viewBox="0 0 14 10" fill="none" data-id="element-101">
              <path d="M1 5h12M8 1l5 4-5 4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-102" />
            </svg>
          </div>
          <span className="text-white font-heading font-semibold text-sm tracking-[0.2em] uppercase" data-id="element-103">
            WELCOME TO B&D CONTRACTING
          </span>
        </div>

        <h1 className="text-5xl md:text-7xl lg:text-[5.5rem] font-bold text-white leading-[1.05] mb-10 max-w-5xl" data-id="element-104">
          BUILD YOUR CAREER WITH A GULF COAST LEADER IN{' '}
          <span className="text-primary" data-id="element-105">SKILLED LABOR STAFFING</span>
        </h1>

        <button className="bg-white text-dark px-8 py-4 flex items-center gap-4 font-heading font-bold uppercase tracking-wider text-lg hover:bg-gray-100 transition-colors group w-fit rounded-sm" data-id="element-106">
          FIND A JOB
          <div className="bg-primary text-white rounded-full p-1.5 group-hover:bg-primary-hover transition-colors" data-id="element-107">
            <ArrowRight size={18} data-id="element-108" />
          </div>
        </button>
      </div>
    </section>;
}